<iframe *ngIf="safeRichContent" id="rich-content-iframe" title="Content" [style.height]="iframeHeight + 'px'" [srcdoc]="safeRichContent">
</iframe>
<div *ngIf="safeRichContent && showExpandControls" class="button-row">
  <button *ngIf="!iframeContentHeight || iframeHeight < iframeContentHeight" mat-button color="primary" (click)="expandFrame()">
    <mat-icon class="with-text">unfold_more</mat-icon>{{ 'Expand' | translate:locale.language }}
  </button>
  <button *ngIf="iframeHeight > maxAutoIframeHeight" mat-button color="primary" (click)="resetFrame()">
    <mat-icon class="with-text">unfold_less</mat-icon>{{ 'Reset' | translate:locale.language }}
  </button>
</div>